<div class="overlay-backdrop" (click)="onBackdropClick($event)">
  <div class="content" (click)="$event.stopPropagation()">
    <div class="payment-loader">
      <div class="pad">
        <div class="chip"></div>
        <div class="line line1"></div>
        <div class="line line2"></div>
      </div>
    </div>

    <div class="heading-2-semi-bold pay-title">{{ 'payment_link_created' | translate }}</div>

    <div class="body-1-medium pay-subtitle">
      {{
        'waiting_payment' | translate
      }}
    </div>

    <app-x-button [size]="'24'" (click)="openLink.emit()">{{ 'open_pay_link' | translate }} </app-x-button>
  </div>
</div>
